module.exports = __webpack_public_path__ + "static/img/pars6.7a56f33a.png";